import { fetchQaqcDistributionPlotSamplesForCsvRows } from "./qaqcDistributionSamplesFetch.js";
import { buildDistributionSamplesCsvContent } from "./distributionCsvHelpers.js";

/**
 * Loads sample rows via distribution-plot API (no plotKey / listType) and builds CSV text.
 * Columns (see buildDistributionSamplesCsvContent): Sample ID, Asset, Field, Well, Reservoir, Fluid Sample ID, plot metric.
 */
export async function buildDistributionPlotCsvStringFromApi({
  plotName,
  qcDistributionTestName,
  qcDistributionFluidType,
  plotColumnHeader,
}) {
  const pn = String(plotName ?? "").trim();
  if (!pn) {
    return { csv: "", rowCount: 0 };
  }
  const hdr = String(plotColumnHeader ?? "").trim();
  const rows = await fetchQaqcDistributionPlotSamplesForCsvRows({
    testName: qcDistributionTestName,
    plotName: pn,
    fluidType: qcDistributionFluidType,
  });
  return {
    csv: buildDistributionSamplesCsvContent(rows, hdr),
    rowCount: rows.length,
  };
}
